import React, { useEffect } from "react";
import "./home.css";

import { NavLink, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";

import StepsSection from "../components/StepsSection";
import HomeEstimates from "../components/HomeEstimet";
import HomeEstimatescopy from "../components/HomeEstimetcopy";
import HomeFaq from "../components/HomeFaq.js";
import HomeProduct from "../components/HomeProduct";
import Whoweare from "../components/Whoweare";
import Testimonial from "../components/Testimonial.js";
import MyForm from "../components/MyForm.js";

const Home = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="page-content">
      <Helmet>
        <title>Integrated Interior</title>
        <meta name="description" content="lorem" />
      </Helmet>

      <div className="home-banner-wrapper">
        <div className="homebanner position-relative">
          <div className="img">
            <img src="./images/banner.jpg" alt="" />
          </div>
          <div className="overlay"></div>
          <div className="text-wrapper home-banner-content">
            <div className="container">
              <div className="row align-items-center  banner-h py-4">
                <div className="col-md-6 ">
                <div className="img-iso-top">
                
                <img src="./images/iso.png" alt="" />
               
              </div>
                  <div className="text">
                    <h1>Integrated Interior</h1>
                    <p>Transforming Spaces into Masterpieces</p>
                    <p>
                      Your one-stop solution for office, home, and shop
                      interiors, along with premium furniture.
                    </p>
                    <NavLink to="/contact" className="btn">
                      Contact Us
                    </NavLink>
                  </div>
                </div>
                <div className="col-md-6 mb-4 mb-md-0">
                  <MyForm />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <HomeEstimates />
      <StepsSection />
      <HomeEstimatescopy />
      <Whoweare />
      <Testimonial />
      <HomeFaq />
    </div>
  );
};

export default Home;
